import React from 'react'

export default function TitleH1({title}: { title: string }) {
    return (
        <h1 className="title-h1">
            {title}
        </h1>
    )
}
